{
  "url.connect": "/conexion",
  "url.donate": "/donar",
  "url.community": "/comunidad/{id}-{slug}",
  "url.menu.contact": "/contactar",
  "url.menu.introduction": "/pagina/introduction",
  "url.menu.about": "/page/about",
  "url.menu.communities-list": "/lista-de-comunidades",
  "url.menu.cgu": "/pagina/cgu",
  "url.menu.events": "/page/evenements",
  "url.menu.guides-list": "/guides-list"
}
